import React, { useContext, useCallback, useEffect } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './index.scss';

import { getKamDetails, getLeadStatus, getHardwareType, fsCancelOrderOnClick, fsProceedBtnOnClick } from 'home/view/upgrade-order/utils';

import { USER_TYPE, LEAD_STATUS, ORDER_STATUS, ACTIVE_TABS, SERVICE_TYPE, HARDWARE_TYPE, MEDIA_TYPES } from 'home/view/upgrade-order/constants';

import { CONTEXT } from 'home/view/upgrade-order/context';

import { DOA_STATUS } from '../../../constants/common-constants';

const FooterComponent = ({
  leadData = {},
  setShowCancelPopup = () => {},
  isFormValid = true,
  pnqFormOpen = false,
  setConfirmOrderPopup = () => {},
  checkFeasibility = () => {},
  // setConfirmPricingPopup = () => {},
  setShowSubmitOrderPopup = () => {},
  loading = false,
  errors = {},
  setSubmitClicked = () => {},
  activeTab = '',
  selectedServiceType = {},
  setConfirmPricingKamPopup = () => {},
  selectedBandwidth = {},
  poFormOpen = {},
  blockJourney = false,
  lowerPriceBw = false,
  selectedPrimaryMedia = {},
  orderDetail,
  onSubmitClick,
  isSubmitDisabled,
  isCancelDisabled
}) => {
  const { userType } = useContext(CONTEXT);

  const { firstName, email, phoneNumber } = getKamDetails(leadData) || {};

  const leadStatus = getLeadStatus(leadData);
  const doaStatus = leadData && leadData.doaStatus;

  // const checkErrors = () => {
  //   const errorCopy = { ...errors };
  //   if (userType === USER_TYPE.CUSTOMER || !pnqFormOpen || (userType === USER_TYPE.KAM && activeTab === ACTIVE_TABS.STANDARD_PRICE)) {
  //     errorCopy.rentalCost = [];
  //     errorCopy.otcCost = [];
  //     errorCopy.clarityRequired = [];
  //   }

  //   if (userType === USER_TYPE.KAM && activeTab === ACTIVE_TABS.CUSTOM_PRICE && !doaStatus) {
  //     errorCopy.clarityRequired = [];
  //   }

  //   if (selectedServiceType && selectedServiceType.key !== SERVICE_TYPE.MANAGED) {
  //     errorCopy.cpe = [];
  //     errorCopy.cpeSpecification = [];
  //   }

  //   let hasError = false;

  //   Object.entries(errorCopy).forEach(([key, value]) => {
  //     if (key && value && value.length > 0) {
  //       hasError = true;
  //     }
  //   });

  //   return hasError;
  // };

  // const onSubmitClick = async () => {
  //   setSubmitClicked(true);
  //   const hasFormError = checkErrors();

  //   if (!hasFormError) {
  //     fsProceedBtnOnClick(leadData, userType);
  //     switch (leadStatus) {
  //       case LEAD_STATUS.LEAD_IN_PROGRESS: {
  //         checkFeasibility();
  //         break;
  //       }
  //       case LEAD_STATUS.FEASIBILITY_COMPLETED: {
  //         const isSelectedMediaOffnetOrThirdParty =
  //           selectedPrimaryMedia &&
  //           selectedPrimaryMedia.hasOwnProperty('key') &&
  //           (selectedPrimaryMedia.key === MEDIA_TYPES.OFFNET || selectedPrimaryMedia.key === MEDIA_TYPES.THIRD_PARTY);

  //         const isNonStandardHardware = () => {
  //           const hardwareType = getHardwareType(leadData);

  //           if (hardwareType) {
  //             return hardwareType === HARDWARE_TYPE.NON_STANDARD;
  //           }

  //           return false;
  //         };

  //         if (userType === USER_TYPE.CUSTOMER) {
  //           if (pnqFormOpen && !isNonStandardHardware() && !lowerPriceBw && !isSelectedMediaOffnetOrThirdParty) {
  //             setConfirmOrderPopup(true);
  //           } else {
  //             setConfirmPricingPopup(true);
  //           }
  //         } else {
  //           if (pnqFormOpen) {
  //             setConfirmPricingKamPopup(true);
  //           } else {
  //             setConfirmPricingPopup(true);
  //           }
  //         }
  //         break;
  //       }
  //       case LEAD_STATUS.LEAD_SUBMITTED: {
  //         setConfirmOrderPopup(true);
  //         break;
  //       }
  //       case LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION:
  //       case LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT: {
  //         if (pnqFormOpen) {
  //           setConfirmPricingKamPopup(true);
  //         } else {
  //           setConfirmPricingPopup(true);
  //         }
  //         break;
  //       }
  //       case LEAD_STATUS.KYC_IN_PROGRESS: {
  //         setShowSubmitOrderPopup(true);
  //         break;
  //       }

  //       case LEAD_STATUS.KYC_SUBMITTED: {
  //         if (orderDetail.orderStatus === ORDER_STATUS.OV_REJECTED) {
  //           setShowSubmitOrderPopup(true);
  //         }
  //         break;
  //       }

  //       default: {
  //         return () => {};
  //       }
  //     }
  //   }
  // };

  // const isSubmitDisabled = useCallback(() => {
  //   if (!leadStatus) {
  //     return true;
  //   }

  //   const hasFormError = checkErrors();

  //   const { upgradeFormBwChanged, upgradeFormMediaChanged, upgradeFormServiceTypeChanged, upgradeFormHardwareDetailsChanged, upgradeFormAuthorisedSignatoryChanged } = errors;

  //   const isLeadUpdatedAfterFeasibility = leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED && (upgradeFormHardwareDetailsChanged || upgradeFormAuthorisedSignatoryChanged);

  //   const upgradeFieldsUpdated = upgradeFormBwChanged || upgradeFormMediaChanged || upgradeFormServiceTypeChanged || isLeadUpdatedAfterFeasibility;

  //   const isLeadInProgress = () => {
  //     return (
  //       leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS ||
  //       leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED ||
  //       leadStatus === LEAD_STATUS.LEAD_SUBMITTED ||
  //       leadStatus === LEAD_STATUS.KYC_IN_PROGRESS
  //     );
  //   };

  //   const isRentalZero = () => {
  //     const rental = selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.prices && selectedBandwidth.plan.prices.RATE.charge;

  //     return parseInt(rental) === 0 ? true : false;
  //   };

  //   const isStandardRate = () => {
  //     return (selectedBandwidth && selectedBandwidth.plan && selectedBandwidth.plan.standardRate) || false;
  //   };

  //   const isNonStandardHardware = () => {
  //     const hardwareType = getHardwareType(leadData);

  //     if (hardwareType) {
  //       return !isLeadInProgress() && hardwareType === HARDWARE_TYPE.NON_STANDARD;
  //     }

  //     return false;
  //   };

  //   const isZeroRateCard = () => {
  //     return !isLeadInProgress() && isRentalZero() && !isStandardRate();
  //   };

  //   const doaStatus = leadData && leadData.doaStatus;

  //   if (userType === USER_TYPE.CUSTOMER) {
  //     return (
  //       hasFormError ||
  //       isNonStandardHardware() ||
  //       isZeroRateCard() ||
  //       blockJourney ||
  //       (!pnqFormOpen && !poFormOpen && !upgradeFieldsUpdated) ||
  //       leadStatus === LEAD_STATUS.FEASIBILITY_PENDING ||
  //       leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE ||
  //       leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION ||
  //       leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT ||
  //       leadStatus === LEAD_STATUS.PRICING_DOA_REJECTED ||
  //       (leadStatus === LEAD_STATUS.KYC_IN_PROGRESS && !isFormValid) ||
  //       (leadStatus === LEAD_STATUS.KYC_SUBMITTED && leadStatus !== ORDER_STATUS.OV_REJECTED && !isFormValid)
  //     );
  //   }
  //   if (userType === USER_TYPE.KAM) {
  //     return (
  //       hasFormError ||
  //       (activeTab === ACTIVE_TABS.STANDARD_PRICE && (isZeroRateCard() || lowerPriceBw)) ||
  //       (!pnqFormOpen && !poFormOpen && !upgradeFieldsUpdated) ||
  //       leadStatus === LEAD_STATUS.PRICING_DOA_APPROVED ||
  //       leadStatus === LEAD_STATUS.PRICING_DOA_REJECTED ||
  //       leadStatus === LEAD_STATUS.FEASIBILITY_PENDING ||
  //       leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE ||
  //       leadStatus === LEAD_STATUS.LEAD_SUBMITTED ||
  //       leadStatus === LEAD_STATUS.KYC_IN_PROGRESS ||
  //       leadStatus === LEAD_STATUS.KYC_SUBMITTED ||
  //       (leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT && doaStatus !== DOA_STATUS.CLARITY_REQUIRED)
  //     );
  //   }
  // }, [leadStatus, userType, errors, isFormValid]);

  // const isCancelDisabled = () => {
  //   if (!leadStatus) {
  //     return true;
  //   }

  //   if (userType === USER_TYPE.CUSTOMER) {
  //     return (
  //       loading ||
  //       leadStatus === LEAD_STATUS.FEASIBILITY_PENDING ||
  //       leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE ||
  //       leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION ||
  //       leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT ||
  //       leadStatus === LEAD_STATUS.KYC_SUBMITTED
  //     );
  //   }
  //   if (userType === USER_TYPE.KAM) {
  //     return (
  //       loading ||
  //       leadStatus === LEAD_STATUS.FEASIBILITY_PENDING ||
  //       leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE ||
  //       leadStatus === LEAD_STATUS.LEAD_SUBMITTED ||
  //       leadStatus === LEAD_STATUS.PRICING_DOA_REJECTED ||
  //       leadStatus === LEAD_STATUS.KYC_SUBMITTED ||
  //       (leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT && doaStatus !== DOA_STATUS.CLARITY_REQUIRED)
  //     );
  //   }
  // };

  useEffect(() => {
    document.getElementById('root').className = 'footer-strip';
    return () => document.getElementById('root').classList.remove('footer-strip');
  }, []);

  return (
    <div
      className="single_upgrade_footer active"
      style={{
        zIndex: 9999
      }}
    >
      <div className="b2b-lib-container">
        <div className="inside-plan show_full_view">
          <div className="plan-info">
            {userType === USER_TYPE.CUSTOMER && firstName && email && phoneNumber && (
              <div className="plan_details_veiw">
                <div className="left_col">
                  <div className="manage_account_details">
                    <div className="kam-border" />
                    {firstName && <div className="manager_name">{`Key Account Manager: ${firstName}`}</div>}
                    {email && <div className="manager_email">{email}</div>}
                    {phoneNumber && <div className="manager_phone">{phoneNumber}</div>}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="plan-details">
            <div className="action">
              <Button
                variant="outlinebtn"
                onClick={() => {
                  setShowCancelPopup(true);
                  fsCancelOrderOnClick(leadData, userType);
                }}
                disabled={isCancelDisabled()}
                style={{
                  borderRadius: '#D3D3D4',
                  marginRight: 15,
                  borderColor: '#D3D3D4',
                  width: 170,
                  height: 45,
                  color: '#303536'
                }}
              >
                Cancel Order
              </Button>
              <Button
                className="activebtn"
                disabled={loading || isSubmitDisabled()}
                onClick={onSubmitClick}
                style={{
                  width: 150,
                  height: 45
                }}
              >
                Proceed
                {loading && <span className="loading_icon"></span>}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(FooterComponent);
